import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ConfirmDialog from '../../../components/nir/ConfirmDialog';
import FilterDropDown from '../../../components/nir/FilterDropDown';
import { ppsiCreateFromGlobalNirRoute } from '../../../routes/index';
import { FormattedMessage } from 'react-intl';
import { Typography, makeStyles } from '@material-ui/core';
import { getMarketName } from '../../app/selectors';

const useStyles = makeStyles({
  typography: {
    fontSize: '1.3rem',
    fontWeight: 400
  }
});

const useConnectDishToPpsiNir = localDishes => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [formulaCode, setFormulaCode] = useState('');
  const [globalPpsiId, setGlobalPpsiId] = useState(null);
  const [enrichmentDataId, setEnrichmentDataId] = useState(null);
  const [globalPiaArticleNumber, setGlobalPiaArticleNumber] = useState(null);
  const userMarket = useSelector(getMarketName);
  const classes = useStyles();

  const handleConfirm = () => {
    const route = ppsiCreateFromGlobalNirRoute(
      userMarket,
      formulaCode,
      globalPpsiId,
      enrichmentDataId,
      globalPiaArticleNumber
    );
    history.push(route);
    onCloseDialog();
  };

  const onOpenDialog = (globalPpsiId, enrichmentId, globalPiaArticleNumber) => {
    setGlobalPpsiId(globalPpsiId);
    setEnrichmentDataId(enrichmentId);
    setGlobalPiaArticleNumber(globalPiaArticleNumber);
    setIsOpen(true);
  };

  const onCloseDialog = () => {
    setIsOpen(false);
    setGlobalPpsiId(null);
    setFormulaCode('');
    setEnrichmentDataId(null);
    setGlobalPiaArticleNumber(null);
  };

  const dishItems = localDishes
    .map(dish => ({
      value: dish.formulaCode,
      label: dish.piaItemName
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const handleSelect = value => {
    setFormulaCode(value);
  };

  const dialog = (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onCloseDialog}
      onConfirm={handleConfirm}
      isConfirmDisabled={
        formulaCode === '' ||
        globalPiaArticleNumber === null ||
        globalPiaArticleNumber === undefined
      }
      title={<FormattedMessage id="prompt.copyGlobalInstructionNirLabel" />}
    >
      <Typography variant="body1" className={classes.typography}>
        <FormattedMessage id="prompt.contentSelectLocalNirDish" />
      </Typography>
      <FilterDropDown
        value={formulaCode}
        onSelect={handleSelect}
        items={dishItems}
        id="localUnpublishedNirDish"
        label={<FormattedMessage id="prompt.localDishDropdownNirLabel" />}
        noResultMessage={
          <FormattedMessage id="prompt.localDishNoResultNirMessage" />
        }
      />
      <Typography variant="caption">
        <FormattedMessage id="prompt.contentSelectLocalNirDishEditInfo" />
      </Typography>
    </ConfirmDialog>
  );

  return [dialog, onOpenDialog];
};

export default useConnectDishToPpsiNir;
